import {useContext} from 'react'
import {OrderAuditContext} from '../../context'
import OrderAuditTableRow from './OrderAuditTableRow'
import {DynamicTable} from '../../../../components/DynamicTable'
import {columns} from '../../utils'

const OrderAuditTable = () => {
  const {
    tabView,
    orderAuditList,
    isLoading,
    filters,
    onSortingChange,
    hasWritePermission,
    isOperationLoading,
  } = useContext(OrderAuditContext)

  return (
    <DynamicTable
      id='order-audit-table'
      data={orderAuditList}
      filters={filters}
      sortableColumns={columns(tabView || '')}
      onSortingChange={onSortingChange}
      loading={isLoading || isOperationLoading}
      tableRowProps={{tabView}}
      hasPermission={hasWritePermission}
      TableRow={OrderAuditTableRow}
    />
  )
}

export default OrderAuditTable
